import script from "./InstructionEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./InstructionEdit.vue?vue&type=script&setup=true&lang=js"

import "./InstructionEdit.vue?vue&type=style&index=0&id=3af8706c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3af8706c"]])

export default __exports__